import React, { useState } from 'react';
import {
	Grid,
	IconButton,
	Dialog,
	Slide
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Search } from '@material-ui/icons';

import AutoCompleteInput from './AutoCompleteInput';

export default function HeaderSearchBox(props) {
	const [open, setOpen] = useState(false);
	const { searchProducts, updateProducts, width } = props || {};
	const { searchBy, mobileView, customAttributes } = props;
	const { searchBox } = customAttributes || {};
	if ((searchBox && searchBox === 'none') || window.location.pathname !== '/') return null;
	const theme = useTheme();
	const useStyles = makeStyles({
		dialog: {
			position: 'absolute',
			top: '10%',
			borderRadius: '5px',
			padding: '0px',
			width: '80%',
			margin: 0,
			minHeight: '255px',
			backgroundColor: 'transparent',
			boxShadow: 'none',
		}
	});
	const classes = useStyles();

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const mobileMenu = (
		<>
			<IconButton
				color="inherit"
				aria-label="open drawer"
				edge="start"
				onClick={handleClickOpen}
				style={{ outline: 0, padding: '5px', margin: '0px' }}
				data-cy="mobileSearchButton"
			>
				<Search style={{ fill: theme.palette.primary.main, fontSize: '30px' }} />
			</IconButton>
			<Dialog
				open={open}
				TransitionComponent={Slide}
				keepMounted
				onClose={handleClose}
				classes={{ paper: classes.dialog }}
			>
				<AutoCompleteInput
					onEnterPress={searchProducts}
					searchBy={searchBy}
					updateProducts={updateProducts}
					handleMobileDialogClose={handleClose}
					width={width}
					handleClose={handleClose}
				/>
			</Dialog>
		</>
	);

	const desktopMenu = (
		<Grid container>
			<Grid item xs={12} style={{ margin: '0px 10px' }}>
				<AutoCompleteInput
					onEnterPress={searchProducts}
					searchBy={searchBy}
					updateProducts={updateProducts}
					handleClose={handleClose}
				/>
			</Grid>
		</Grid>
	);

	return (
		mobileView ? mobileMenu : desktopMenu
	);
}
